__turbopack_context__.v({
  "arrow": "FooterLinksMobile-module-scss-module__7VgmIq__arrow",
  "body": "FooterLinksMobile-module-scss-module__7VgmIq__body",
  "bodyWrapper": "FooterLinksMobile-module-scss-module__7VgmIq__bodyWrapper",
  "button": "FooterLinksMobile-module-scss-module__7VgmIq__button",
  "container": "FooterLinksMobile-module-scss-module__7VgmIq__container",
  "default": "FooterLinksMobile-module-scss-module__7VgmIq__default",
  "link": "FooterLinksMobile-module-scss-module__7VgmIq__link",
  "links": "FooterLinksMobile-module-scss-module__7VgmIq__links",
  "slide-down": "FooterLinksMobile-module-scss-module__7VgmIq__slide-down",
  "slide-up": "FooterLinksMobile-module-scss-module__7VgmIq__slide-up",
});
